
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SchemeNodeModel } from '@/models/schemeNodeModel';

@Component({
  name: 'AssessBySkillMenu',
})
export default class AssessBySkillMenu extends Vue {
  /**
   * LevelTree
   * Passed from the assess by skill page.
   * This is the schemes level only nodes ready filtered by levels relevant to the selected groups members.
   * This is an array as is children of root.
   *
   * @private
   * @property {SchemeNodeModel}
   */
  @Prop() private levelTree!: Array<SchemeNodeModel>;
  @Prop({ default: false }) private completeOnly!: boolean;

  /**
   *Computed getter.  Returns this instances levelTree value.
   *
   * @return {Array<SchemeNodeModel>>}
   */
  get levelNodes(): Array<SchemeNodeModel> {
    return this.levelTree;
  }

  /**
   * Formats each nodes name suitable for URL display, it is then attached to that skills link as a param.
   *
   * @param {SchemeNodeModel} node
   * @return {string}
   */
  getNodeLinkName(node: SchemeNodeModel): string {
    return node.title ? node.title.replace(/\s+/g, '-').toLowerCase() : '';
  }
}
